import React from "react";
import { FieldGroupRow, FieldGroupRowStatus } from "../../../models/intake";
import FormConstants from "./DataEntryFieldsConstants";
import { writeFieldToForm } from "./formFieldHelpers";
import DateField from "../../../common/formFields/DateField";
import { DEFAULT_MIN_DATE } from "../../../common/constants/ApiConstants";

export interface RequestDateFieldProps {
    /** Currently selected Request date (read from DATA_ENTRY_FIELDS_FORM). */
    readonly value?: Date | string;
    /** Hides the field entirely - classic pane's requestType != DISCLOSURE_ACCOUNTING gate. */
    readonly visible: boolean;
    readonly dispatch: Function;
    readonly formName?: string;
    /**
     * Extra, non-form side effect the caller wants to run on change (the
     * classic pane's autosave PATCH). The base DATA_ENTRY_FIELDS_FORM write
     * is always handled by this component itself via writeFieldToForm -
     * callers should NOT also dispatch a redundant form write here.
     */
    readonly onRequestDateChange?: (newValue?: Date | string) => void;
}

/**
 * Shared Request Date field (Spec #34098 / F1a). Always required when
 * visible (unlike Authorization Date, which is conditionally required).
 * Rendered by both the classic RightPane Details tab and the new Quick
 * Entry row.
 */
const RequestDateField: React.FC<RequestDateFieldProps> = (props) => {
    if (!props.visible) {
        return null;
    }

    const formName = props.formName ?? FormConstants.DATA_ENTRY_FIELDS_FORM;

    const onChange = (value?: Date | string) => {
        writeFieldToForm(props.dispatch, FormConstants.REQUEST_DATE, value, formName);
        props.onRequestDateChange?.(value);
    };

    return (
        <DateField
            label="Request date"
            placeholder="mm/dd/yyyy"
            maxDate={new Date()}
            minDate={DEFAULT_MIN_DATE}
            required
            errMsg=""
            onChange={onChange}
            value={props.value}
        />
    );
};

export default RequestDateField;

export const REQUEST_DATE_ROW_ID = "requestDate";

/** Builds the FieldGroupRow for the Request Date row - always required when visible. */
export function mapRequestDateToFieldGroupRow(badgeNumber: number, formValue: Date | string | undefined): FieldGroupRow {
    const hasValue = formValue !== undefined && formValue !== null && formValue !== "";

    return {
        id: REQUEST_DATE_ROW_ID,
        badgeNumber,
        status: hasValue ? FieldGroupRowStatus.Confirmed : FieldGroupRowStatus.NeedsEntry,
        label: "Request Date",
        value: hasValue ? String(formValue) : null,
        isAiPreSelected: false,
    };
}
